<template>
    <cadastro-simples-list
        endpoint="tipo-distancia"
        rota-base="/admin/tipo-distancia"
        titulo="TIPOS DE DISTÂNCIA"
        titulo-singular="Tipo de Distância"
        :colunas-extras='[{"campo":"distancia_minima_km","label":"Distância mínima (km)","tipo":"string"},{"campo":"distancia_maxima_km","label":"Distância máxima (km)","tipo":"string"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
